import { defineMessages } from 'react-intl';

const deliveryMessages = defineMessages({
    headerEgc: {
        id: 'delivery.deliveryMessages.headerEgc',
        description: 'Top-level heading for choosing where the digital gift card should be delivered',
        defaultMessage: 'Where is it going?'
    },
    headerPlastic: {
        id: 'delivery.deliveryMessages.headerPlastic',
        description: 'Top-level heading for choosing where the plastic gift card should be delivered',
        defaultMessage: 'Where is it going?'
    },
    plasticButton: {
        id: 'delivery.deliveryMessages.plasticButton',
        description: 'Text displayed on the shipping details sub-heading',
        defaultMessage: 'Shipping'
    },
    emailLabel: {
        id: 'delivery.deliveryMessages.emailLabel',
        description: 'Label text for recipient email input',
        defaultMessage: '{name}\'s email'
    },
    emailLabelNoName: {
        id: 'delivery.deliveryMessages.emailLabelNoName',
        description: 'Label text for recipient email input if we do not have a recipient name',
        defaultMessage: 'Recipient\'s email'
    },
    emailHelper: {
        id: 'delivery.deliveryMessages.emailHelper',
        description: 'Helper text for the recipient email input',
        defaultMessage: 'This tells us where to email the egift card.'
    },
    emailRequired: {
        id: 'delivery.deliveryMessages.emailRequired',
        description: 'Error message displayed when no delivery email is provided',
        defaultMessage: 'Please enter an email'
    },
    emailInvalid: {
        id: 'delivery.deliveryMessages.emailInvalid',
        description: 'Error message displayed when an invalid delivery email is provided',
        defaultMessage: 'Please enter a valid email address'
    },
    smsPhoneInvalid: {
        id: 'delivery.deliveryMessages.smsPhoneInvalid',
        description: 'Error messages displayed when an invalid SMS delivery phone number is provided',
        defaultMessage: 'Please enter a valid phone number'
    },
    recipientNotificationLabel: {
        id: 'delivery.deliveryMessages.recipientNotificationLabel',
        description: 'Label text for toggling notification to the recipient of a physical delivery',
        defaultMessage: 'Tell {name} to expect a gift?'
    },
    submitButtonText: {
        id: 'delivery.deliveryMessages.submitButtonPhysicalText',
        description: 'Text shown on preceding steps on buttons which will move the user to the delivery step',
        defaultMessage: 'Where is it going?'
    }
});

export default deliveryMessages;
